import * as React from 'react';
import {FlatList, Pressable, StyleSheet, TextInput, TouchableOpacity} from 'react-native';
import { View, Text, Image } from 'react-native';
import {DrawerActions, useNavigation} from "@react-navigation/native";
import {Avatar} from "react-native-paper";
import {windowWidth} from "../utils/Dimentions";
import {Ionicons, AntDesign, MaterialCommunityIcons, Entypo} from '@expo/vector-icons';
import CardItem from "../components/CardItem";




export default function Home() {
    const navigation = useNavigation();
    const userImage = require("../assets/john.png")


    return (
    <View style={styles.container}>
        <View style={styles.header}>
            <View style={styles.headerLeft}>

            </View>
            <View style={styles.headerRight}>
                <View style={styles.right}>
                    <Ionicons name="notifications" size={18} color="#52525A" />
                    <View style={styles.lang}>
                        <Text style={styles.text0}>EN</Text>
                        <Entypo name="chevron-down" size={18} color="#52525A" />
                    </View>
                </View>
                <View style={styles.left}>
                    <View>
                        <Text style={styles.text1}>John Doe</Text>
                        <Text style={styles.text2}>Oxford University</Text>
                    </View>
                    <TouchableOpacity style={styles.avatar} onPress={() => ({})}>
                        <Avatar.Image
                            source={{uri: userImage}}
                            size={40}
                        />
                    </TouchableOpacity>
                </View>
            </View>
        </View>

        <View style={styles.mainContainer}>
            <View style={styles.leftContainer}>
                <TouchableOpacity style={styles.back} onPress={() => navigation.navigate('Dashboard')}>
                    <Ionicons name="chevron-back-outline" size={18} color="black" />
                    <Text style={styles.text1}>Back</Text>
                </TouchableOpacity>
                <View style={styles.upContainer}>
                    <View style={styles.profile}>
                        <Text style={styles.text3}>Verify Student Academic Credential</Text>
                        <Text style={styles.text4}>
                            To verify student credentials, please kindly select
                            your preferred mode of verification using the dropdown
                            button as shown below.
                        </Text>
                        <TouchableOpacity style={styles.modeButton} onPress={() => navigation.navigate('Verify-Mode')}>
                            <Text style={styles.modeText}>Select mode of verification</Text>
                            <Entypo name="chevron-down" size={18} color="#52525A" />
                        </TouchableOpacity>

                    </View>
                </View>
            </View>

            <View style={styles.rightContainer}>

            </View>
        </View>

    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'center',
    backgroundColor: 'white',
  },
   mainContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    width: '95%',
    flex: 1,
    marginBottom: 10,
   },
   leftContainer: {
    height: '100%',
    alignItems: 'flex-start',
    width: '60%',
       marginLeft: 40,
   },
   upContainer: {
    height: '50%',
    alignItems: 'center',
    backgroundColor: 'whitesmoke',
       width: '90%',
       borderRadius: 20,
       flexDirection: 'row',
       justifyContent: 'space-around',
   },
   bottomContainer: {
    height: '67%',
    alignItems: 'center',
       justifyContent: 'space-around',
       width: '100%',
   },
   rightContainer: {
    height: '100%',
    alignItems: 'center',
    width: '30%',
   },
  header: {
      width: '95%',
      height: 60,
      alignItems: 'center',
      justifyContent: 'space-between',
      flexDirection: 'row',
      top: 10,
      marginBottom: 20,
  },
  headerLeft: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      width: '30%',
      height: 40,
      borderRadius: 20,
      backgroundColor: 'transparent',
  },
  headerRight: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-around',
      width: '25%',
      height: 40,
      borderRadius: 20,
  },
    searchBox: {
      marginLeft: 20,
      borderWidth: 0,
      height: 25,
      width: 250,
      marginRight: 20,
  },
  lang: {
      flexDirection: 'row',
      marginLeft: 20,
      justifyContent: 'center',
      alignItems: 'center',
  },
  left: {
      flexDirection: 'row',
      alignItems: 'center',
  },
  right: {
      flexDirection: 'row',
      alignItems: 'center',
  },
  text0: {
      fontSize: 14,
      fontWeight: '500',
      color: 'black',
      marginRight: 10,
  },
  text1: {
      fontSize: 14,
      fontWeight: '500',
      color: 'black',
  },
  text2: {
      fontSize: 12,
      color: 'gray',
  },
  textButton: {
      fontSize: 10,
      color: 'whitesmoke',
      fontWeight: '500',
  },
  text3: {
      fontSize: 14,
      fontWeight: '500',
      color: 'black',
      marginBottom: 10,
  },
  text6: {
      fontSize: 12,
      fontWeight: '500',
      color: 'grey',
  },
  text7: {
      fontSize: 12,
      color: 'black',
  },
  text4: {
      fontSize: 12,
      color: 'black',
      marginBottom: 10,
      lineHeight: 20,
  },
  text5: {
      fontSize: 14,
      color: 'white',
  },
  avatar: {
      marginLeft: 10,
      marginRight: 10,
  },
  profile: {
      width: '80%',
      alignItems: 'flex-start',
      justifyContent: 'center',
      marginLeft: 40,
  },
  button: {
      backgroundColor: 'black',
      height: 30,
      width: 120,
      borderRadius: 7,
      alignItems: 'center',
      justifyContent: 'center',
      marginLeft: 350,
  },
  back: {
      backgroundColor: 'transparent',
      height: 30,
      width: 120,
      borderRadius: 7,
      alignItems: 'center',
      justifyContent: 'flex-start',
      flexDirection: 'row',
      marginBottom: 30,
  },
  modeButton: {
      backgroundColor: 'white',
      height: 40,
      width: '95%',
      borderRadius: 20,
      alignItems: 'center',
      justifyContent: 'space-around',
      flexDirection: 'row',
      marginTop: 30,
      marginBottom: 30,
      shadowOffset: { width: 0, height: 1 },
      shadowOpacity: 0.8,
      shadowRadius: 2,
      shadowColor: 'gray',
      elevation: 2,
  },
  modeText: {
      fontWeight: "500",
      color: 'gray',
  },
    imageContainer: {
      width: '30%',
      marginLeft: 20,
      marginTop: 10,
      marginBottom: 10,
      height: '90%',
  },
  image: {
      resizeMode: "contain",
      height: '100%',
      width: '100%',
  },
  history: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      width: '95%',
  },
   historyContainer: {
        height: '43%',
        alignItems: 'center',
       justifyContent: 'center',
        width: '100%',
        borderRadius: 20,
        flexDirection: 'row',
       marginTop: 10,
   },
    boxContainer: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '75%',
        height: '9%',
        backgroundColor: '#ffffff',
        borderRadius: 10,
        marginTop: 20,
        shadowOffset: { width: 0, height: 1 },
        shadowOpacity: 0.8,
        shadowRadius: 2,
        shadowColor: 'gray',
        elevation: 2,
    },
    logoContainer: {
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        marginLeft: 20,
    },
    textContainer: {
        marginLeft: 20,
        alignItems: 'flex-start',
        justifyContent: 'center',
        textAlign: 'left',
    },
    textAnalytics: {
        alignItems: 'flex-start',
        justifyContent: 'center',
        textAlign: 'left',
        width: '75%',
        marginTop: 30,
    },
    graphContainer: {
        alignItems: 'center',
        width: '75%',
        height: '35%',
        backgroundColor: '#ffffff',
        borderRadius: 10,
        marginTop: 20,
    },
    graph: {
      resizeMode: 'cover',
        height: '100%',
        width: '100%',
    },
});
